define('directives/tinyMce/tinyMce',['app', 'settings', 'uiBootstrap'], function (app) {
	'use strict';
	app.directive('ngTinyMce', [
		'BASE_DIRECTIVES_PATH',
		function (BASE_DIRECTIVES_PATH) {
			return {
				scope: {
					html: '=',
					rows: '=?',
				},
				templateUrl: BASE_DIRECTIVES_PATH + '/tinyMce/views/tinyMce.html',
				controller: [
					'$scope',
					function ($scope) {
						if ($scope.rows === undefined) {
							$scope.rows = 5;
						}

						$scope.tinymceOptions = {
							theme: 'modern',
							height: '500',
							convert_urls: false,
							relative_urls: false,
							remove_script_host: false,
							plugins: [
								'link advlist lists image charmap print preview hr anchor pagebreak',
								'searchreplace wordcount visualblocks visualchars code fullscreen',
								'insertdatetime media nonbreaking save table contextmenu directionality',
								'emoticons template paste textcolor colorpicker textpattern imagetools',
								'fullpage moodiaimage shortcodes',
							],
							menubar: 'insert | tools',
							toolbar1:
								'insertfile undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link moodiaimage',
							toolbar2:
								'print preview media | forecolor backcolor emoticons | fontsizeselect | fontselect | code | shortcodes',
							image_advtab: true,
						};
					},
				],
			};
		},
	]);
});

